// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.4
// source: bridge/models/transaction.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "core.bridge";

export interface TransactionIdentifier {
  depositChainId: string;
  depositTxHash: string;
  depositTxIndex: string;
}

export interface Transaction {
  depositChainId: string;
  depositTxHash: string;
  depositTxIndex: string;
  depositBlock: string;
  depositToken: string;
  depositAmount: string;
  depositor: string;
  receiver: string;
  withdrawalChainId: string;
  withdrawalTxHash: string;
  withdrawalToken: string;
  signature: string;
  isWrapped: boolean;
  withdrawalAmount: string;
  commissionAmount: string;
  txData: string;
  referralId: number;
  merkleProof: string;
  epochId: number;
}

export interface Submissions {
  hash: string;
  submitters: string[];
}

function createBaseTransactionIdentifier(): TransactionIdentifier {
  return { depositChainId: "", depositTxHash: "", depositTxIndex: "0" };
}

export const TransactionIdentifier: MessageFns<TransactionIdentifier> = {
  encode(message: TransactionIdentifier, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.depositChainId !== "") {
      writer.uint32(10).string(message.depositChainId);
    }
    if (message.depositTxHash !== "") {
      writer.uint32(18).string(message.depositTxHash);
    }
    if (message.depositTxIndex !== "0") {
      writer.uint32(24).uint64(message.depositTxIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransactionIdentifier {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransactionIdentifier();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.depositChainId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.depositTxHash = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.depositTxIndex = reader.uint64().toString();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransactionIdentifier {
    return {
      depositChainId: isSet(object.depositChainId)
        ? globalThis.String(object.depositChainId)
        : isSet(object.deposit_chain_id)
        ? globalThis.String(object.deposit_chain_id)
        : "",
      depositTxHash: isSet(object.depositTxHash)
        ? globalThis.String(object.depositTxHash)
        : isSet(object.deposit_tx_hash)
        ? globalThis.String(object.deposit_tx_hash)
        : "",
      depositTxIndex: isSet(object.depositTxIndex)
        ? globalThis.String(object.depositTxIndex)
        : isSet(object.deposit_tx_index)
        ? globalThis.String(object.deposit_tx_index)
        : "0",
    };
  },

  toJSON(message: TransactionIdentifier): unknown {
    const obj: any = {};
    if (message.depositChainId !== "") {
      obj.depositChainId = message.depositChainId;
    }
    if (message.depositTxHash !== "") {
      obj.depositTxHash = message.depositTxHash;
    }
    if (message.depositTxIndex !== "0") {
      obj.depositTxIndex = message.depositTxIndex;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TransactionIdentifier>, I>>(base?: I): TransactionIdentifier {
    return TransactionIdentifier.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TransactionIdentifier>, I>>(object: I): TransactionIdentifier {
    const message = createBaseTransactionIdentifier();
    message.depositChainId = object.depositChainId ?? "";
    message.depositTxHash = object.depositTxHash ?? "";
    message.depositTxIndex = object.depositTxIndex ?? "0";
    return message;
  },
};

function createBaseTransaction(): Transaction {
  return {
    depositChainId: "",
    depositTxHash: "",
    depositTxIndex: "0",
    depositBlock: "0",
    depositToken: "",
    depositAmount: "",
    depositor: "",
    receiver: "",
    withdrawalChainId: "",
    withdrawalTxHash: "",
    withdrawalToken: "",
    signature: "",
    isWrapped: false,
    withdrawalAmount: "",
    commissionAmount: "",
    txData: "",
    referralId: 0,
    merkleProof: "",
    epochId: 0,
  };
}

export const Transaction: MessageFns<Transaction> = {
  encode(message: Transaction, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.depositChainId !== "") {
      writer.uint32(10).string(message.depositChainId);
    }
    if (message.depositTxHash !== "") {
      writer.uint32(18).string(message.depositTxHash);
    }
    if (message.depositTxIndex !== "0") {
      writer.uint32(24).uint64(message.depositTxIndex);
    }
    if (message.depositBlock !== "0") {
      writer.uint32(32).uint64(message.depositBlock);
    }
    if (message.depositToken !== "") {
      writer.uint32(42).string(message.depositToken);
    }
    if (message.depositAmount !== "") {
      writer.uint32(50).string(message.depositAmount);
    }
    if (message.depositor !== "") {
      writer.uint32(58).string(message.depositor);
    }
    if (message.receiver !== "") {
      writer.uint32(66).string(message.receiver);
    }
    if (message.withdrawalChainId !== "") {
      writer.uint32(74).string(message.withdrawalChainId);
    }
    if (message.withdrawalTxHash !== "") {
      writer.uint32(82).string(message.withdrawalTxHash);
    }
    if (message.withdrawalToken !== "") {
      writer.uint32(90).string(message.withdrawalToken);
    }
    if (message.signature !== "") {
      writer.uint32(98).string(message.signature);
    }
    if (message.isWrapped !== false) {
      writer.uint32(104).bool(message.isWrapped);
    }
    if (message.withdrawalAmount !== "") {
      writer.uint32(114).string(message.withdrawalAmount);
    }
    if (message.commissionAmount !== "") {
      writer.uint32(122).string(message.commissionAmount);
    }
    if (message.txData !== "") {
      writer.uint32(130).string(message.txData);
    }
    if (message.referralId !== 0) {
      writer.uint32(136).uint32(message.referralId);
    }
    if (message.merkleProof !== "") {
      writer.uint32(146).string(message.merkleProof);
    }
    if (message.epochId !== 0) {
      writer.uint32(152).uint32(message.epochId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Transaction {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransaction();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.depositChainId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.depositTxHash = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.depositTxIndex = reader.uint64().toString();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.depositBlock = reader.uint64().toString();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.depositToken = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.depositAmount = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.depositor = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.receiver = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.withdrawalChainId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.withdrawalTxHash = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.withdrawalToken = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.signature = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.isWrapped = reader.bool();
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.withdrawalAmount = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 122) {
            break;
          }

          message.commissionAmount = reader.string();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.txData = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 136) {
            break;
          }

          message.referralId = reader.uint32();
          continue;
        }
        case 18: {
          if (tag !== 146) {
            break;
          }

          message.merkleProof = reader.string();
          continue;
        }
        case 19: {
          if (tag !== 152) {
            break;
          }

          message.epochId = reader.uint32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Transaction {
    return {
      depositChainId: isSet(object.depositChainId)
        ? globalThis.String(object.depositChainId)
        : isSet(object.deposit_chain_id)
        ? globalThis.String(object.deposit_chain_id)
        : "",
      depositTxHash: isSet(object.depositTxHash)
        ? globalThis.String(object.depositTxHash)
        : isSet(object.deposit_tx_hash)
        ? globalThis.String(object.deposit_tx_hash)
        : "",
      depositTxIndex: isSet(object.depositTxIndex)
        ? globalThis.String(object.depositTxIndex)
        : isSet(object.deposit_tx_index)
        ? globalThis.String(object.deposit_tx_index)
        : "0",
      depositBlock: isSet(object.depositBlock)
        ? globalThis.String(object.depositBlock)
        : isSet(object.deposit_block)
        ? globalThis.String(object.deposit_block)
        : "0",
      depositToken: isSet(object.depositToken)
        ? globalThis.String(object.depositToken)
        : isSet(object.deposit_token)
        ? globalThis.String(object.deposit_token)
        : "",
      depositAmount: isSet(object.depositAmount)
        ? globalThis.String(object.depositAmount)
        : isSet(object.deposit_amount)
        ? globalThis.String(object.deposit_amount)
        : "",
      depositor: isSet(object.depositor) ? globalThis.String(object.depositor) : "",
      receiver: isSet(object.receiver) ? globalThis.String(object.receiver) : "",
      withdrawalChainId: isSet(object.withdrawalChainId)
        ? globalThis.String(object.withdrawalChainId)
        : isSet(object.withdrawal_chain_id)
        ? globalThis.String(object.withdrawal_chain_id)
        : "",
      withdrawalTxHash: isSet(object.withdrawalTxHash)
        ? globalThis.String(object.withdrawalTxHash)
        : isSet(object.withdrawal_tx_hash)
        ? globalThis.String(object.withdrawal_tx_hash)
        : "",
      withdrawalToken: isSet(object.withdrawalToken)
        ? globalThis.String(object.withdrawalToken)
        : isSet(object.withdrawal_token)
        ? globalThis.String(object.withdrawal_token)
        : "",
      signature: isSet(object.signature) ? globalThis.String(object.signature) : "",
      isWrapped: isSet(object.isWrapped)
        ? globalThis.Boolean(object.isWrapped)
        : isSet(object.is_wrapped)
        ? globalThis.Boolean(object.is_wrapped)
        : false,
      withdrawalAmount: isSet(object.withdrawalAmount)
        ? globalThis.String(object.withdrawalAmount)
        : isSet(object.withdrawal_amount)
        ? globalThis.String(object.withdrawal_amount)
        : "",
      commissionAmount: isSet(object.commissionAmount)
        ? globalThis.String(object.commissionAmount)
        : isSet(object.commission_amount)
        ? globalThis.String(object.commission_amount)
        : "",
      txData: isSet(object.txData)
        ? globalThis.String(object.txData)
        : isSet(object.tx_data)
        ? globalThis.String(object.tx_data)
        : "",
      referralId: isSet(object.referralId)
        ? globalThis.Number(object.referralId)
        : isSet(object.referral_id)
        ? globalThis.Number(object.referral_id)
        : 0,
      merkleProof: isSet(object.merkleProof)
        ? globalThis.String(object.merkleProof)
        : isSet(object.merkle_proof)
        ? globalThis.String(object.merkle_proof)
        : "",
      epochId: isSet(object.epochId)
        ? globalThis.Number(object.epochId)
        : isSet(object.epoch_id)
        ? globalThis.Number(object.epoch_id)
        : 0,
    };
  },

  toJSON(message: Transaction): unknown {
    const obj: any = {};
    if (message.depositChainId !== "") {
      obj.depositChainId = message.depositChainId;
    }
    if (message.depositTxHash !== "") {
      obj.depositTxHash = message.depositTxHash;
    }
    if (message.depositTxIndex !== "0") {
      obj.depositTxIndex = message.depositTxIndex;
    }
    if (message.depositBlock !== "0") {
      obj.depositBlock = message.depositBlock;
    }
    if (message.depositToken !== "") {
      obj.depositToken = message.depositToken;
    }
    if (message.depositAmount !== "") {
      obj.depositAmount = message.depositAmount;
    }
    if (message.depositor !== "") {
      obj.depositor = message.depositor;
    }
    if (message.receiver !== "") {
      obj.receiver = message.receiver;
    }
    if (message.withdrawalChainId !== "") {
      obj.withdrawalChainId = message.withdrawalChainId;
    }
    if (message.withdrawalTxHash !== "") {
      obj.withdrawalTxHash = message.withdrawalTxHash;
    }
    if (message.withdrawalToken !== "") {
      obj.withdrawalToken = message.withdrawalToken;
    }
    if (message.signature !== "") {
      obj.signature = message.signature;
    }
    if (message.isWrapped !== false) {
      obj.isWrapped = message.isWrapped;
    }
    if (message.withdrawalAmount !== "") {
      obj.withdrawalAmount = message.withdrawalAmount;
    }
    if (message.commissionAmount !== "") {
      obj.commissionAmount = message.commissionAmount;
    }
    if (message.txData !== "") {
      obj.txData = message.txData;
    }
    if (message.referralId !== 0) {
      obj.referralId = Math.round(message.referralId);
    }
    if (message.merkleProof !== "") {
      obj.merkleProof = message.merkleProof;
    }
    if (message.epochId !== 0) {
      obj.epochId = Math.round(message.epochId);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Transaction>, I>>(base?: I): Transaction {
    return Transaction.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Transaction>, I>>(object: I): Transaction {
    const message = createBaseTransaction();
    message.depositChainId = object.depositChainId ?? "";
    message.depositTxHash = object.depositTxHash ?? "";
    message.depositTxIndex = object.depositTxIndex ?? "0";
    message.depositBlock = object.depositBlock ?? "0";
    message.depositToken = object.depositToken ?? "";
    message.depositAmount = object.depositAmount ?? "";
    message.depositor = object.depositor ?? "";
    message.receiver = object.receiver ?? "";
    message.withdrawalChainId = object.withdrawalChainId ?? "";
    message.withdrawalTxHash = object.withdrawalTxHash ?? "";
    message.withdrawalToken = object.withdrawalToken ?? "";
    message.signature = object.signature ?? "";
    message.isWrapped = object.isWrapped ?? false;
    message.withdrawalAmount = object.withdrawalAmount ?? "";
    message.commissionAmount = object.commissionAmount ?? "";
    message.txData = object.txData ?? "";
    message.referralId = object.referralId ?? 0;
    message.merkleProof = object.merkleProof ?? "";
    message.epochId = object.epochId ?? 0;
    return message;
  },
};

function createBaseSubmissions(): Submissions {
  return { hash: "", submitters: [] };
}

export const Submissions: MessageFns<Submissions> = {
  encode(message: Submissions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.hash !== "") {
      writer.uint32(10).string(message.hash);
    }
    for (const v of message.submitters) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Submissions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubmissions();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.hash = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.submitters.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Submissions {
    return {
      hash: isSet(object.hash) ? globalThis.String(object.hash) : "",
      submitters: globalThis.Array.isArray(object?.submitters)
        ? object.submitters.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Submissions): unknown {
    const obj: any = {};
    if (message.hash !== "") {
      obj.hash = message.hash;
    }
    if (message.submitters?.length) {
      obj.submitters = message.submitters;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Submissions>, I>>(base?: I): Submissions {
    return Submissions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Submissions>, I>>(object: I): Submissions {
    const message = createBaseSubmissions();
    message.hash = object.hash ?? "";
    message.submitters = object.submitters?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
